import { render } from "./ClientHome.vue?vue&type=template&id=4a303036"
import script from "./ClientHome.vue?vue&type=script&lang=js"
export * from "./ClientHome.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__